module.exports = __webpack_public_path__ + "img/iphone-frame2x-cropped.2b1992c5.png";